export default objectArray => objectArray.map(({ displayText, id, requiresManualEntry, parentConfigId}) => ({
    value: id,
    label: displayText,
    requiresManualEntry,
    parentConfigId: parentConfigId
}));